/**
 * Created by neo on 30.05.2024
 */
import { makeAutoObservable } from 'mobx';
import { Audited, createAuditedFields } from '../Audited';
import { HttpBackend } from '../../Services/Http/HttpBackend';
import { Media } from '../Media/Media';
import { CoachTts } from '../Coach/TextToSpeech/CoachTts';

// Raw JSON from backend
export type CoachTtsVoiceJson = Audited & {
  identifier: string;
  name: string;
  paused: boolean;
  selected: boolean;
};

// Observable model type
export type CoachTtsVoice = Audited & Omit<CoachTtsVoiceJson, keyof Audited>;

// Factory function
export function createCoachTtsVoice(json?: Partial<CoachTtsVoiceJson>): CoachTtsVoice {
  const audited = createAuditedFields(json);

  return makeAutoObservable({
    ...audited,
    identifier: json?.identifier ?? '',
    name: json?.name ?? '',
    paused: json?.paused ?? true,
    selected: json?.selected ?? false,
  });
}

// Static API methods
export const CoachTtsVoiceApi = {
  list(): Promise<CoachTtsVoice[]> {
    return HttpBackend.get('/coach/text-to-speech/voices').then((response: CoachTtsVoiceJson[]) =>
      response.map((json) => createCoachTtsVoice(json)),
    );
  },

  current(): Promise<CoachTtsVoice | undefined> {
    return HttpBackend.get('/coach/text-to-speech/current-voice').then((json) =>
      json ? createCoachTtsVoice(json) : undefined,
    );
  },
};
